export type FilteredOptions = {
    visible: string[];
    showNoMatches: boolean;
};

export type OptionSearchKeyAction = 'none' | 'prevent-submit' | 'clear';

const ALL_OPTION = '';

/**
 * Narrows the rendered option labels. The empty string is the existing "All" choice
 * and stays visible. The source list and any selection array are left unchanged.
 */
export function filterOptionList(options: readonly string[], query: string): FilteredOptions {
    const normalized = query.trim().toLocaleLowerCase();

    if (normalized === '') {
        return {visible: options.slice(), showNoMatches: false};
    }

    const visible: string[] = [];
    let namedMatch = false;

    for (const option of options) {
        if (option === ALL_OPTION) {
            visible.push(option);
            continue;
        }

        if (option.toLocaleLowerCase().includes(normalized)) {
            visible.push(option);
            namedMatch = true;
        }
    }

    return {visible, showNoMatches: !namedMatch};
}

/**
 * Enter must not submit a surrounding form. Escape clears only while a query is
 * present; an empty query returns none so the mobile drawer can still close.
 */
export function optionSearchKeyAction(key: string, query: string): OptionSearchKeyAction {
    if (key === 'Enter') {
        return 'prevent-submit';
    }

    if (key === 'Escape' && query !== '') {
        return 'clear';
    }

    return 'none';
}
